import { createReducer, on } from '@ngrx/store';
import { CareActions } from './care.actions';
import { CareState, initialCareState } from './models/care-state.models';

export const careReducer = createReducer(
  initialCareState,

  // Load care recipients
  on(CareActions.loadCareRecipients, (state): CareState => ({
    ...state,
    loading: true,
    error: null
  })),
  on(CareActions.loadCareRecipientsSuccess, (state, { careRecipients }): CareState => ({
    ...state,
    careRecipients,
    loading: false,
    error: null
  })),
  on(CareActions.loadCareRecipientsFailure, (state, { error }): CareState => ({
    ...state,
    loading: false,
    error
  })),

  // Revoke link
  on(CareActions.revokeLink, (state): CareState => ({
    ...state,
    loading: true,
    error: null
  })),
  on(CareActions.revokeLinkSuccess, (state): CareState => ({
    ...state,
    loading: false,
    error: null
  })),
  on(CareActions.revokeLinkFailure, (state, { error }): CareState => ({
    ...state,
    loading: false,
    error
  })),

  // Select recipient
  on(CareActions.selectRecipient, (state, { userId }): CareState => ({
    ...state,
    selectedRecipientId: userId
  })),

  // Clear state
  on(CareActions.clearCareState, (): CareState => ({
    ...initialCareState
  })),
);
